/* Out-of-stock size selector.
 *
 * The previous "substitute product" popup intercepted clicks on out-of-stock
 * size pills and blocked Klaviyo's native "Notify me when back in stock" form.
 * That popup has been removed. This script only keeps out-of-stock size pills
 * selectable so the theme's normal variant-selection flow runs and Klaviyo's
 * back-in-stock form can fire. No candidates are resolved, no dialog is
 * opened, and no clicks are intercepted.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) {
    module.exports = api;
    return;
  }
  root.HealixOOSAlternative = api;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', api.boot);
  else api.boot();
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  function isSizeOption(button) {
    return String((button && button.getAttribute && button.getAttribute('data-option-name')) || '').trim().toLowerCase() === 'size';
  }

  function sizeOptions(variantRoot) {
    if (!variantRoot) return [];
    return Array.prototype.slice.call(variantRoot.querySelectorAll('.product-variants-block__pill[data-option-name]')).filter(isSizeOption);
  }

  function makeSelectable(button) {
    if (!button || !button.disabled) return;
    button.disabled = false;
    button.classList.remove('is-unavailable', 'oos-alt-available', 'oos-alt-selectable');
  }

  function process(variantRoot) {
    sizeOptions(variantRoot).forEach(makeSelectable);
  }

  function initRoot(featureRoot) {
    if (!featureRoot || featureRoot.hasAttribute('data-oos-alt-ready')) return;
    featureRoot.setAttribute('data-oos-alt-ready', '');
    var variantRoot = document.getElementById(featureRoot.getAttribute('data-variant-root-id') || '');
    if (!variantRoot) return;

    process(variantRoot);

    // The theme's own variant selector re-disables unavailable pills every
    // time the selected options change; keep re-enabling size pills so
    // sold-out sizes stay selectable for Klaviyo's back-in-stock form.
    var observer = new MutationObserver(function () {
      process(variantRoot);
    });
    observer.observe(variantRoot, { attributes: true, subtree: true, attributeFilter: ['disabled'] });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-oos-alt-root]:not([data-oos-alt-ready])');
    for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
  }

  return {
    isSizeOption: isSizeOption,
    sizeOptions: sizeOptions,
    makeSelectable: makeSelectable,
    initRoot: initRoot,
    boot: boot
  };
});
